import {
  Room,
  RoomCardEntity,
  RoomCardEntityType,
  SplitBooking
} from '../../types/room'

/**
 * Maps a room object to an abstract offer format
 * @param room - Room object containing room details and offers
 * @returns Abstract offer object with room data and metadata
 */
export const mapRoomToAbstract = (
  room: Room
): Extract<RoomCardEntity, {type: RoomCardEntityType.Regular}> => ({
  id: room.id,
  type: RoomCardEntityType.Regular,
  data: room
})

/**
 * Maps SB object to an abstract offer format
 * @param splitBooking - SB object
 * @returns Abstract offer object with room data and metadata
 */
export const mapSplitBookingToAbstract = (
  splitBooking: SplitBooking
): Extract<RoomCardEntity, {type: RoomCardEntityType.SplitBooking}> => ({
  id: splitBooking.bundleId,
  type: RoomCardEntityType.SplitBooking,
  data: splitBooking
})
